import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    tables: [],
    join_type: "left join"
};

export const researchSlice = createSlice({
    name: "research",
    initialState,
    reducers: {
        addTable: (state, { payload }) => {
            const id = Math.random();
            const { form_name } = payload;
            state.tables.push(
                {
                    form_id: id,
                    form_name,
                }
            );
        },
        dropTables: (state) => { state.tables = [] },
        changeJoin: (state, { payload }) => {
            state.join_type = payload;
        },
        changeColumn: (state, { payload }) => {
            const { columns, index } = payload;
            state.tables[index].column_list = [...columns];
        },
        resetColumns: (state) => {
            state.tables.forEach(table => table.column_list = state.tables[0].column_list);
        },
    }
})

export const { addTable, dropTables, changeColumn, resetColumns } = researchSlice.actions

export default researchSlice.reducer